import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, s as setBearerAuthToObject, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * CouponsApi - axios parameter creator
 * @export
 */
const CouponsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/Coupons/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CouponsDevExtremeGetGridRequest} [CouponsDevExtremeGetGridRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPost: async (CouponsDevExtremeGetGridRequest, options = {}) => {
            const localVarPath = `/v1/Coupons/GetAllPost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CouponsDevExtremeGetGridRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/Coupons/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System,FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrderEvents: async (id, options = {}) => {
            const localVarPath = `/v1/Coupons/GetCouponOrderEvents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [CouponId]
         * @param {number} [OrderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrderLines: async (CouponId, OrderId, options = {}) => {
            const localVarPath = `/v1/Coupons/GetCouponOrderLines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (CouponId !== undefined) {
                localVarQueryParameter['CouponId'] = CouponId;
            }
            if (OrderId !== undefined) {
                localVarQueryParameter['OrderId'] = OrderId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CouponToken} [CouponToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (CouponToken, options = {}) => {
            const localVarPath = `/v1/Coupons/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CouponToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Coupons/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CouponToken} [CouponToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (CouponToken, options = {}) => {
            const localVarPath = `/v1/Coupons/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CouponToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Validates the provided coupon.  If the user is logged in customer, validation is executed against this customer specifically.  If the user is guest, and an e-mail is provided in the request, validation is executed against this specific email only;             the e-mail is never resolved to a customer account, so customer-restricted and logged-in-only coupons are not unlocked by it.  If the requested coupon code is a template coupon, and the user is a logged-in user, then validation is executed             for that customer\'s specific personalized coupon. If a personalized coupon does not exist, a new personalized coupon             is created
         * @summary Validates a coupon (and creates personalized coupon if needed)
         * @param {ActivateCouponRequest} [ActivateCouponRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate: async (ActivateCouponRequest, options = {}) => {
            const localVarPath = `/v1/Coupons/Validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ActivateCouponRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CouponsApi - functional programming interface
 * @export
 */
const CouponsApiFp = function (configuration) {
    const localVarAxiosParamCreator = CouponsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CouponsDevExtremeGetGridRequest} [CouponsDevExtremeGetGridRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPost(CouponsDevExtremeGetGridRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPost(CouponsDevExtremeGetGridRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System,FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponOrderEvents(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponOrderEvents(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getCouponOrderEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [CouponId]
         * @param {number} [OrderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponOrderLines(CouponId, OrderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponOrderLines(CouponId, OrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getCouponOrderLines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CouponToken} [CouponToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(CouponToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(CouponToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CouponToken} [CouponToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(CouponToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(CouponToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  Validates the provided coupon.  If the user is logged in customer, validation is executed against this customer specifically.  If the user is guest, and an e-mail is provided in the request, validation is executed against this specific email only;             the e-mail is never resolved to a customer account, so customer-restricted and logged-in-only coupons are not unlocked by it.  If the requested coupon code is a template coupon, and the user is a logged-in user, then validation is executed             for that customer\'s specific personalized coupon. If a personalized coupon does not exist, a new personalized coupon             is created
         * @summary Validates a coupon (and creates personalized coupon if needed)
         * @param {ActivateCouponRequest} [ActivateCouponRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validate(ActivateCouponRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validate(ActivateCouponRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.validate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CouponsApi - factory interface
 * @export
 */
const CouponsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CouponsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CouponsDevExtremeGetGridRequest} [CouponsDevExtremeGetGridRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPost(CouponsDevExtremeGetGridRequest, options) {
            return localVarFp.getAllPost(CouponsDevExtremeGetGridRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System,FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrderEvents(id, options) {
            return localVarFp.getCouponOrderEvents(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [CouponId]
         * @param {number} [OrderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrderLines(CouponId, OrderId, options) {
            return localVarFp.getCouponOrderLines(CouponId, OrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CouponToken} [CouponToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(CouponToken, options) {
            return localVarFp.insert(CouponToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CouponToken} [CouponToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(CouponToken, options) {
            return localVarFp.update(CouponToken, options).then((request) => request(axios, basePath));
        },
        /**
         *  Validates the provided coupon.  If the user is logged in customer, validation is executed against this customer specifically.  If the user is guest, and an e-mail is provided in the request, validation is executed against this specific email only;             the e-mail is never resolved to a customer account, so customer-restricted and logged-in-only coupons are not unlocked by it.  If the requested coupon code is a template coupon, and the user is a logged-in user, then validation is executed             for that customer\'s specific personalized coupon. If a personalized coupon does not exist, a new personalized coupon             is created
         * @summary Validates a coupon (and creates personalized coupon if needed)
         * @param {ActivateCouponRequest} [ActivateCouponRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(ActivateCouponRequest, options) {
            return localVarFp.validate(ActivateCouponRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CouponsApi - object-oriented interface
 * @export
 * @class CouponsApi
 * @extends {BaseAPI}
 */
class CouponsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    getAll(options) {
        return CouponsApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {CouponsDevExtremeGetGridRequest} [CouponsDevExtremeGetGridRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    getAllPost(CouponsDevExtremeGetGridRequest, options) {
        return CouponsApiFp(this.configuration).getAllPost(CouponsDevExtremeGetGridRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    getById(id, options) {
        return CouponsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System,FrontEndUsers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    getCouponOrderEvents(id, options) {
        return CouponsApiFp(this.configuration).getCouponOrderEvents(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [CouponId]
     * @param {number} [OrderId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    getCouponOrderLines(CouponId, OrderId, options) {
        return CouponsApiFp(this.configuration).getCouponOrderLines(CouponId, OrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CouponToken} [CouponToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    insert(CouponToken, options) {
        return CouponsApiFp(this.configuration).insert(CouponToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    remove(id, options) {
        return CouponsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {CouponToken} [CouponToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    update(CouponToken, options) {
        return CouponsApiFp(this.configuration).update(CouponToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Validates the provided coupon.  If the user is logged in customer, validation is executed against this customer specifically.  If the user is guest, and an e-mail is provided in the request, validation is executed against this specific email only;             the e-mail is never resolved to a customer account, so customer-restricted and logged-in-only coupons are not unlocked by it.  If the requested coupon code is a template coupon, and the user is a logged-in user, then validation is executed             for that customer\'s specific personalized coupon. If a personalized coupon does not exist, a new personalized coupon             is created
     * @summary Validates a coupon (and creates personalized coupon if needed)
     * @param {ActivateCouponRequest} [ActivateCouponRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    validate(ActivateCouponRequest, options) {
        return CouponsApiFp(this.configuration).validate(ActivateCouponRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export { CouponsApi, CouponsApiAxiosParamCreator, CouponsApiFactory, CouponsApiFp };
//# sourceMappingURL=coupons-api.js.map
